import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { refreshToken, isTokenExpired } from "./fileUploadSlice";

const baseUrl = process.env.REACT_APP_API_URL || "https://api.naturalremediesapp.com/api";

export const symptomsApiService = createApi({
  reducerPath: "symptomsApiService",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      const token = localStorage.getItem("admin_token");
      const tokenExpiry = localStorage.getItem("admin_token_expires_at");

      if (token && isTokenExpired(tokenExpiry)) {
        try {
          const newToken = await refreshToken();
          headers.set("Authorization", `Bearer ${newToken}`);
        } catch (error) {
          window.location.href = "/admin/auth/sign-in";
          throw error;
        }
      } else if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: ["Symptoms"],
  endpoints: (builder) => ({
    getSymptoms: builder.query({
      query: (searchParams = {}) => {
        const params = new URLSearchParams();
        if (searchParams.search) params.append("search", searchParams.search);
        if (searchParams.status) params.append("status", searchParams.status);
        if (searchParams.page) params.append("page", String(searchParams.page));
        if (searchParams.per_page) params.append("per_page", String(searchParams.per_page));
        const queryString = params.toString();
        return { url: `/symptoms${queryString ? `?${queryString}` : ""}` };
      },
      providesTags: ["Symptoms"],
    }),
    getSymptomsForSelection: builder.query({
      query: () => ({ url: "/symptoms/for-selection" }),
      providesTags: ["Symptoms"],
    }),
    createSymptom: builder.mutation({
      query: (body) => ({ url: "/symptoms", method: "POST", body }),
      invalidatesTags: ["Symptoms"],
    }),
    updateSymptom: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/symptoms/${id}`, method: "PUT", body }),
      invalidatesTags: ["Symptoms"],
    }),
    deleteSymptom: builder.mutation({
      query: (id) => ({ url: `/symptoms/${id}`, method: "DELETE" }),
      invalidatesTags: ["Symptoms"],
    }),
    toggleSymptomStatus: builder.mutation({
      query: (id) => ({ url: `/symptoms/${id}/toggle-status`, method: "PATCH" }),
      invalidatesTags: ["Symptoms"],
    }),
  }),
});

export const {
  useGetSymptomsQuery,
  useGetSymptomsForSelectionQuery,
  useCreateSymptomMutation,
  useUpdateSymptomMutation,
  useDeleteSymptomMutation,
  useToggleSymptomStatusMutation,
} = symptomsApiService;
